import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const ManifestoSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      className="relative py-24 md:py-32 px-6 md:px-12 overflow-hidden"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0a0808] to-[#050505]" />
      
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7 }}
            className="lg:col-span-2 relative"
          >
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent z-10" />
              <img
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=800&fit=crop&auto=format"
                alt="Nutricionista profesional"
                className="w-full h-full object-cover grayscale opacity-80"
              />
              {/* Decorative border */}
              <div className="absolute inset-0 border border-white/10 rounded-2xl" />
            </div>
            {/* Accent line */}
            <div className="absolute -right-4 top-1/4 bottom-1/4 w-px bg-gradient-to-b from-transparent via-[#E05D3A] to-transparent" />
          </motion.div>

          {/* Content */}
          <div className="lg:col-span-3">
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5 }}
              className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-6"
            >
              Nuestro Manifiesto
            </motion.span>
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mb-8 leading-tight"
            >
              Creemos que el nutricionista{" "}
              <span className="text-gradient">debería escuchar, no documentar.</span>
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="space-y-4 text-zinc-400 text-base sm:text-lg leading-relaxed"
            >
              <p>
                Creamos Antropia después de ver a nutricionistas excepcionales perder horas 
                documentando lo que sus oídos ya habían escuchado.
              </p>
              <p>
                Creemos que la tecnología debe ser invisible. Que la IA debe potenciar, no 
                reemplazar. Que cada minuto que ahorras documentando es un minuto que puedes 
                invertir en tu cliente.
              </p>
              <p>
                Cuando el nutricionista puede enfocarse 100% en su cliente, los resultados 
                mejoran. La adherencia aumenta. Los clientes regresan. El negocio crece.
              </p>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="mt-8 text-white font-outfit italic"
            >
              — El equipo de Antropia
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};
